import React, { Component } from 'react';
import classNames from 'classnames';
import NameEditor from '../../components/poi-sheet/NameEditor';
import s from './HostStyles.module.scss';

export default class NameEditorPlayground extends Component {
    constructor(props) {
        super(props);
        this.state = {
            name: 'Petunia',
            showMessage: false,
        };
    }

    onNameChange = newName => this.setState({ name: newName, showMessage: true });

    render() {
        return (
            <div className={classNames(s.editor, s.nameEditor)}>
                <NameEditor name={this.state.name} onChange={this.onNameChange} />
                {this.state.showMessage && <div>The name was changed to {this.state.name}</div>}
            </div>
        );
    }
}
